/**
 * Helps handling dropdown items such as menus, accordion items, etc.
 *
 * @package Qustodio_Theme\Scripts
 */

const dropdown = () => ({
  open: false,

  toggleDropdown() {
    this.open = !this.open;
  },

  closeDropdown() {
    this.open = false;
  },

  get isDropdownOpen() {
    return this.open;
  },
});

export default dropdown;
